<template>
    <!-- eslint-disable vue/no-static-inline-styles -->
    <component
        :is="getValue('tag')"
        :to="getValue('to')"
        :href="getValue('tag') === 'a' ? getValue('href') : undefined"
        class="r-card r-card--colorful"
        :style="{height: onSize('r-card--height', getValue('height', height)), backgroundColor: getValue('color')}"
        :class="getValue('classes')"
    >
        <img
            v-if="getValue('image')"
            :src="imgSrc(getValue('image'), getValue('imageVersion'))"
            :alt="getValue('title')"
            class="r-card__image"
        >

        <h3
            v-if="getValue('title')"
            class="r-card__title"
            v-html="getValue('title')"
        />

        <y-button
            v-if="getValue('buttonContent')"
            :size="onSize('button', getValue('buttonSize'))"
            :content="getValue('buttonContent')"
            :color="getValue('buttonColor')"
            :tag="getValue('buttonTag')"
            :href="getValue('href')"
            :to="getValue('to')"
            outline
            flat
        />
    </component>
</template>

<script>
    import { Component, Mixins } from 'vue-property-decorator';
    import Card from '@rogues/Card/shared/card';
    
    @Component
    /**
     * @name Colorful
     */
    export default class Colorful extends Mixins(Card) {
        responsive = {
            'r-card--height': {
                768: '160px',
            },
            button: {
                768: 'normal',
            },
        }
    }
</script>
